import React from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { Link } from 'react-router-dom';

const { Title } = Typography;

/**
 * Consistent page header with breadcrumb and title.
 *
 * Props:
 *   title       — page title string
 *   breadcrumbs — array of { label, path? }
 *   extra       — React node shown on the right (e.g. action buttons)
 */
const PageHeader = ({ title, breadcrumbs = [], extra }) => {
  const items = breadcrumbs.map((crumb, i) => ({
    key: i,
    title: crumb.path
      ? <Link to={crumb.path}>{crumb.label}</Link>
      : crumb.label,
  }));

  return (
    <div style={{ marginBottom: 20 }}>
      {items.length > 0 && (
        <Breadcrumb items={items} style={{ marginBottom: 6, fontSize: 13 }} />
      )}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <Title level={4} style={{ margin: 0, fontFamily: 'Poppins, sans-serif', color: 'var(--varexe-gray-900)' }}>
          {title}
        </Title>
        {extra && <Space wrap>{extra}</Space>}
      </div>
    </div>
  );
};

export default PageHeader;
